import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { connect } from '../../Store';
import { ResponsiveMenu } from 'oxyrion-ui/lib/ResponsiveMenu';

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  position: fixed;
  z-index: 42;
  background-color: transparent;
  display: block;
  width: ${rem(100)};
  ${({ theme }) => theme.media.m`
  margin-top: ${rem(125)};
  display: none;
`};
`;

const BurgerWrapper = styled.div`
  cursor: pointer;
  padding: ${rem(22)};
  display: inline-block;
  & > .open1 {
    -webkit-transform: rotate(-45deg) translate(-4px, 4px);
    transform: rotate(-45deg) translate(-4px, 4px);
  }

  & > .open2 {
    opacity: 0;
  }

  & > .open3 {
    -webkit-transform: rotate(45deg) translate(-6px, -6px);
    transform: rotate(45deg) translate(-6px, -6px);
  }
`;

const Bar = styled.div`
  width: ${rem(26)};
  height: ${rem(3)};
  background-color: #000;
  margin: ${rem(4)} 0;
  transition: 0.4s;
`;

const ResponsiveMenuWrapper = styled.div`
  position: relative;
`;

class MobileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOnClickLink(item, activeSectionIds) {
    localStorage.setItem('activeSectionIds', JSON.stringify(activeSectionIds));

    if (item.url) {
      this.props.history.push(item.url);
      this.setState({
        visible: false,
      });
    }

    if (item.popup === 'import') {
      this.setState({
        showImport: true,
      });
    }
  }

  handleOpen() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  render() {
    const { treeData } = this.props;

    return (
      <React.Fragment>
        <HeaderWrapper>
          <BurgerWrapper onClick={() => this.handleOpen()}>
            <Bar className={this.state.visible ? 'open1' : ''} />
            <Bar className={this.state.visible ? 'open2' : ''} />
            <Bar className={this.state.visible ? 'open3' : ''} />
          </BurgerWrapper>
        </HeaderWrapper>
        <ResponsiveMenuWrapper>
          <ResponsiveMenu
            sections={treeData}
            role={this.props.user.role}
            onClickLink={i => this.handleOnClickLink(i)}
            visible={this.state.visible}
          />
        </ResponsiveMenuWrapper>
      </React.Fragment>
    );
  }
}

MobileMenu.propTypes = {
  treeData: PropTypes.arrayOf({}),
};

MobileMenu.defaultProps = {
  treeData: [],
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(withRouter(MobileMenu));



// WEBPACK FOOTER //
// ./src/Components/MobileMenu/index.jsx